export const originatorFieldKeys = [
  'organizationName',
  'address',
  'organizationNmlsId',
  'organizationStateLicenseId',
  'originatorName',
  'originatorNmlsId',
  'originatorStateLicenseId',
  'email',
  'phone',
  'organizationEin',
] as const

export type OriginatorFieldKey = (typeof originatorFieldKeys)[number]

export type OriginatorFieldConfig = {
  title: string
  visible: boolean
}

export type OriginatorInformationConfig = {
  title: string
  fields: Record<OriginatorFieldKey, OriginatorFieldConfig>
}

export const defaultOriginatorInformationConfig = (): OriginatorInformationConfig => ({
  title: 'Loan Originator Information',
  fields: {
    organizationName: { title: 'Organization Name', visible: true },
    address: { title: 'Address', visible: true },
    organizationNmlsId: { title: 'Organization NMLS ID', visible: true },
    organizationStateLicenseId: { title: 'State License ID', visible: true },
    originatorName: { title: 'Originator Name', visible: true },
    originatorNmlsId: { title: 'Originator NMLS ID', visible: true },
    originatorStateLicenseId: { title: 'State License ID', visible: true },
    email: { title: 'Email', visible: true },
    phone: { title: 'Phone', visible: true },
    organizationEin: { title: 'Organization EIN', visible: true },
  },
})

export const mergeOriginatorInformationConfig = (
  value?: Partial<OriginatorInformationConfig> | null,
): OriginatorInformationConfig => {
  const defaults = defaultOriginatorInformationConfig()
  if (!value) return defaults
  const fields = { ...defaults.fields }
  originatorFieldKeys.forEach((key) => {
    const configured = value.fields?.[key]
    if (!configured) return
    fields[key] = {
      title: configured.title || defaults.fields[key].title,
      visible: configured.visible !== false,
    }
  })
  return {
    title: value.title || defaults.title,
    fields,
  }
}
